import * as apiHelpers from '../helpers/API';
import * as types from './actionTypes';
import { setLoading } from './loaderActions';
import { loadUserData } from './userActions';

export function setDashboardPage(dashboardPage) {
  return {
    type: types.SET_DASHBOARD_PAGE,
    dashboardPage,
  };
}

export function setGivingOrganization(organizationForce) {
  return (dispatch, getState) => {
    const { transactions } = getState().transactionsReducer;
    const { organizations } = getState().dashboardReducer;
    const { accountType } = getState().userReducer;
    const lastTransaction = transactions[0];

    if (accountType !== 0 && lastTransaction && organizations.length) {
      const {
        organization: organizationNameFromLastTransaction,
        amount,
      } = lastTransaction;
      const organizationMatch = organizations.find(
        ({ id }) => id === organizationNameFromLastTransaction
      );
      dispatch(selectGivingOrganization(organizationMatch));
      dispatch(setLastGiftAmount(amount));
    } else if (organizationForce) {
      const organizationMatch = organizations.find(
        ({ id }) => id === organizationForce
      );

      if (organizationMatch) {
        dispatch(selectGivingOrganization(organizationMatch));
      }
    }
  };
}

export function setProcessorType(organizationId) {
  return dispatch => {
    apiHelpers.getOrganizationData(organizationId).then(organizationDocument => {
      const { processor_types } = organizationDocument;

      dispatch({
        processorTypes: processor_types,
        type: types.SET_PROCESSOR_TYPES,
      });
    });
  };
}

export function setLastGiftAmount(lastGiftAmount) {
  return {
    type: types.SET_LAST_GIFT_AMOUNT,
    lastGiftAmount,
  };
}

export function selectGivingOrganization(selectedGivingOrganization) {
  return (dispatch, getState) => {
    const { accountType } = getState().userReducer;

    if (selectedGivingOrganization && selectedGivingOrganization.id) {
      dispatch(setProcessorType(selectedGivingOrganization.id));
    }
      dispatch({
        type: types.SET_SELECTED_GIVING_ORGANIZATION,
        selectedGivingOrganization,
      });

      const { user } = getState().userReducer;

      if (accountType === 1) {
        dispatch(loadUserData(user));
      }
    }
}

export function getOrganizations() {
  return async dispatch => {
    const organizations = await apiHelpers.getOrganizations();

    dispatch({
      type: types.GET_ORGANIZATIONS,
      organizations,
    });
  };
}

export function getGivingReport(startDate, endDate, paymentType) {
  return async dispatch => {
    try {
      dispatch(setLoading(true));
      const givingReport = await apiHelpers.getGivingReport(startDate, endDate, paymentType);
      dispatch(setLoading(false));
      return givingReport;
    } catch (e) {
      alert(e && e.message);
      dispatch(setLoading(false));
      return false;
    }
  };
}